import secondaryComponents from "../../../../../components/secondaryComponents";
import { useCreateProduct } from "./useCreateProduct";

const CreateProduct = () => {
  const { isCreatingProduct, handleProductCreation } = useCreateProduct();

  return (
    <secondaryComponents.MetaSetter
      title="Lumi Merchant | Product"
      description="Create product"
    >
      <secondaryComponents.RequestLoaderTrigger>
        <secondaryComponents.SingleProductForm
          handleProductUpdate={handleProductCreation}
          isUpdatingProduct={isCreatingProduct}
        />
      </secondaryComponents.RequestLoaderTrigger>
    </secondaryComponents.MetaSetter>
  );
};

export default CreateProduct;
